<div class="wrapper">
  <p class="room-badge__title left-side" *ngIf="showFull && hasName && isRight">{{ roomName }}</p>
  <div>
    <div class="room-badge__content">{{ roomNumber || roomName }}</div>
    <div class="room-badge__circle" [ngClass]="directionClass"></div>
  </div>
  <p class="room-badge__title right-side" *ngIf="showFull && hasName && !isRight">{{ roomName }}</p>
</div>
